import { render, staticRenderFns } from "./VeterinaryCalendar.vue?vue&type=template&id=0dcff410"
import script from "./VeterinaryCalendar.vue?vue&type=script&lang=js"
export * from "./VeterinaryCalendar.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryCalendar.vue?vue&type=style&index=0&id=0dcff410&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports